import DemographicBarChartContainer from '../../modules/Demographic/containers/DemographicBarChartContainer';
import { AppPaths } from '../../helpers/globals/Constans.ts';

// Sync route definition
export default {
  path: `${AppPaths.HOME}*${AppPaths.DEMOGRAPHIC}`,
  component: DemographicBarChartContainer,
};
